import Vue from 'vue';
import whiteLoading from './whiteLoading.vue';
import loadingCircle from './loadingCircle.vue';
import store from '@/store/index';
import merge from '@/utils/merge';


const Loading = (options) => {
	if (window.__loading) {
		window.__loading.close();
		window.__loading = null;
	}
	let defaults = {
		text: store.state.app.lang == 'cn' ? '正在载入资源，请稍候' : 'Loading',
		showLogo: true
	};

	if (options && options.changeLang) {
		if (options.changeLang == 'cn') {
			defaults.text = '正在载入资源，请稍候';
		}
		else {
			defaults.text = 'Loading';
		}
	}

	options = merge({}, defaults, options);
	const LoadingConstructor = Vue.extend(options.showLogo ? whiteLoading : loadingCircle);
	let instance = new LoadingConstructor({
		data: options
	});
	LoadingConstructor.prototype.close = function () {
		if (options.showLogo) {
			instance.close();
		} else {
			if (this._el != null) {
				document.body.removeChild(this._el); //从body中移除dom
			}
			if (this._instance != null) {
				this._instance.$destroy(); //销毁组件
			}
			if (this._vm != null) {
				this._vm = null; //让GC回收
			}
		}
	};
	if (options.showLogo) {
		store.dispatch('setBlueBg', true);
	}
	instance._vm = instance.$mount();
	instance._el = instance.$el;
	instance._instance = instance;
	document.body.appendChild(instance.$el); // 把生成的提示的dom插入body中
	return instance;
};

export default Loading;
